
import { v4 as uuid } from 'uuid';
import { Component, Vue } from 'vue-property-decorator';

import WSAPageFive from '@/components/WSAPageFive.vue';
import WSAPageFour from '@/components/WSAPageFour.vue';
import WSAPageOne from '@/components/WSAPageOne.vue';
import WSAPageThree from '@/components/WSAPageThree.vue';
import WSAPageTwo from '@/components/WSAPageTwo.vue';
import FormModule from '@/store/modules/form';

@Component({
  components: {
    'wsa-page-one': WSAPageOne,
    'wsa-page-two': WSAPageTwo,
    'wsa-page-three': WSAPageThree,
    'wsa-page-four': WSAPageFour,
    'wsa-page-five': WSAPageFive,
  }
})
export default class WSAForm extends Vue {
  currentPage: number;
  entryId: string;

  pageOneModel: WSAPageOneModel;
  pageTwoModel: WSAPageTwoModel;
  pageThreeModel: WSAPageThreeModel;
  pageFourModel: WSAPageFourModel;
  pageFiveModel: WSAPageFiveModel;

  data() {
    return {
      currentPage: 1,
      entryId: '',
      pageOneModel: null,
      pageTwoModel: null,
      pageThreeModel: null,
      pageFourModel: null,
      pageFiveModel: {
        applicantApproval: false,
        guardianApproval: false,
        guardianName: '',
        guardianPhone: '',
        hasAcceptedEmailNotifications: true
      }
    }
  }

  created() {
    this.entryId = uuid();
  }

  get redirectUrl() {
    return window?.__INITIAL_STATE__?.thankYouUrl;
  }

  handleNextPage() {
    if (this.currentPage < 5) {
      this.currentPage = this.currentPage + 1;
      this.$scrollTo(this.$refs.stepSelector as Element);
    }
  }

  handlePreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
      this.$scrollTo(this.$refs.stepSelector as Element);
    }
  }

  handlePageOneSubmit(model, isNext) {
    this.pageOneModel = model;
    if (isNext) {
      this.handleNextPage();
    } else {
      this.handlePreviousPage();
    }
  }

  handlePageTwoSubmit(model, isNext) {
    this.pageTwoModel = model;
    if (isNext) {
      this.handleNextPage();
    } else {
      this.handlePreviousPage();
    }
  }

  handlePageThreeSubmit(model, isNext) {
    this.pageThreeModel = model;
    if (isNext) {
      this.handleNextPage();
    } else {
      this.handlePreviousPage();
    }
  }

  handlePageFourSubmit(model, isNext) {
    this.pageFourModel = model;
    if (isNext) {
      this.handleNextPage();
    } else {
      this.handlePreviousPage();
    }
  }

  handlePageFiveSubmit(model, isNext) {
    this.pageFiveModel = model;
    if (isNext) {
      this.handleNextPage();
    } else {
      this.handlePreviousPage();
    }
  }

  get isOver18() {
    return this.pageOneModel?.age || 0;
  }

  async submitHandler() {
    const loader = this.$loading.show();
    try {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('wsa');

      const requestModel: WSARequest = {
        firstName: this.pageOneModel.firstName,
        lastName: this.pageOneModel.lastName,
        address: this.pageOneModel.address,
        city: this.pageOneModel.city,
        state: this.pageOneModel.state,
        zip: this.pageOneModel.zip,
        phone: this.pageOneModel.phone,
        email: this.pageOneModel.email,
        highSchoolName: this.pageOneModel.highSchoolName,
        age: this.pageOneModel.age,
        gender: this.pageOneModel.gender,
        howDidYouHearAboutUs: this.pageOneModel.howDidYouHearAboutUs,

        numberOfSportsPlayed: this.pageTwoModel.numberOfSportsPlayed,
        sportOne: this.pageTwoModel.sportOne,
        sportOneGrades: this.pageTwoModel.sportOneGrades,
        sportTwo: this.pageTwoModel.sportTwo,
        sportTwoGrades: this.pageTwoModel.sportTwoGrades,
        sportThree: this.pageTwoModel.sportThree,
        sportThreeGrades: this.pageTwoModel.sportThreeGrades,
        sportFour: this.pageTwoModel.sportFour,
        sportFourGrades: this.pageTwoModel.sportFourGrades,
        sportFive: this.pageTwoModel.sportFive,
        sportFiveGrades: this.pageTwoModel.sportFiveGrades,
        sportSix: this.pageTwoModel.sportSix,
        sportSixGrades: this.pageTwoModel.sportSixGrades,

        numberOfActivities: this.pageTwoModel.numberOfActivities,
        activityOne: this.pageTwoModel.activityOne,
        activityOneGrades: this.pageTwoModel.activityOneGrades,
        activityTwo: this.pageTwoModel.activityTwo,
        activityTwoGrades: this.pageTwoModel.activityTwoGrades,
        activityThree: this.pageTwoModel.activityThree,
        activityThreeGrades: this.pageTwoModel.activityThreeGrades,
        activityFour: this.pageTwoModel.activityFour,
        activityFourGrades: this.pageTwoModel.activityFourGrades,

        recognition: this.pageTwoModel.recognition,

        numberOfJobs: this.pageTwoModel.numberOfJobs,
        jobOneEmployer: this.pageTwoModel.jobOneEmployer,
        jobOneDates: this.pageTwoModel.jobOneDates,
        jobTwoEmployer: this.pageTwoModel.jobTwoEmployer,
        jobTwoDates: this.pageTwoModel.jobTwoDates,
        jobThreeEmployer: this.pageTwoModel.jobThreeEmployer,
        jobThreeDates: this.pageTwoModel.jobThreeDates,

        intendedMajor: this.pageTwoModel.intendedMajor,
        schoolNameOne: this.pageTwoModel.schoolNameOne,
        acceptedToSchoolOne: this.pageTwoModel.acceptedToSchoolOne,
        schoolNameTwo: this.pageTwoModel.schoolNameTwo,
        acceptedToSchoolTwo: this.pageTwoModel.acceptedToSchoolTwo,
        schoolNameThree: this.pageTwoModel.schoolNameThree,
        acceptedToSchoolThree: this.pageTwoModel.acceptedToSchoolThree,

        gpa: this.pageTwoModel.gpa,

        essayOneUrl: this.pageThreeModel.essayOneUrl,
        recommendationOneUrl: this.pageFourModel.recommendationOneUrl,
        recommendationTwoUrl: this.pageFourModel.recommendationTwoUrl,
        transcriptUrl: this.pageFourModel.transcriptUrl,

        applicantApproval: this.pageFiveModel.applicantApproval,
        guardianApproval: this.pageFiveModel.guardianApproval,

        guardianName: this.pageFiveModel.guardianName,
        guardianPhone: this.pageFiveModel.guardianPhone,

        hasAcceptedEmailNotifications: this.pageFiveModel.hasAcceptedEmailNotifications,
        recaptchaToken: token
      };

      await FormModule.submitWSA(requestModel);

      if (this.redirectUrl) {
        window.location.href = this.redirectUrl
      } else {
        this.$toasted.success('Your submission has been received!');
        this.pageOneModel = {
          ...this.pageOneModel,
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          state: '',
          phone: '',
          email: '',
          highSchoolName: '',
          age: '',
          gender: '',
          howDidYouHearAboutUs: '',
        };
        this.pageTwoModel = {
          ...this.pageTwoModel,
          sportOne: '',
          sportTwo: '',
          sportThree: '',
          sportFour: '',
          sportFive: '',
          sportSix: '',
          activityOne: '',
          activityTwo: '',
          activityThree: '',
          activityFour: '',
          recognition: '',
          jobOneEmployer: '',
          jobOneDates: '',
          jobTwoEmployer: '',
          jobTwoDates: '',
          jobThreeEmployer: '',
          jobThreeDates: '',
          intendedMajor: '',
          schoolNameOne: '',
          acceptedToSchoolOne: false,
          schoolNameTwo: '',
          acceptedToSchoolTwo: false,
          schoolNameThree: '',
          acceptedToSchoolThree: false,
          gpa: ''
        };
        this.pageThreeModel = {
          essayOneUrl: '',
          essayOneUrlData: '',
        };
        this.pageFourModel = {
          recommendationOneUrl: '',
          recommendationOneUrlData: '',
          recommendationTwoUrl: '',
          recommendationTwoUrlData: '',
          transcriptUrl: '',
          transcriptUrlData: '',
        };
        this.pageFiveModel = {
          applicantApproval: false,
          guardianApproval: false,
          guardianName: '',
          guardianPhone: '',
          hasAcceptedEmailNotifications: true
        };
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }
}
